import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, getLinkTo, title, groups } = appSections.crossdockingBlocked;
export const crossdockBlockedRoute = {
    path: rootPath,
    lazy: async () => {
        const { BlockedStickersContainer } = await import('@/warehouse/modules/crossdockBlocked');
        return {
            element: (_jsx(ProtectedRoute, { groups: groups, children: _jsx(BlockedStickersContainer, {}) })),
        };
    },
    handle: {
        crumb: ({ params: { crossDockId } }) => _jsx(NavLink, { to: getLinkTo(crossDockId), children: title }),
    },
};
